import { useTheme } from "../lib/theme";

export const BrandLogo = ({ fifty = false, className = "h-9", testid = "brand-logo" }) => {
  const { theme } = useTheme();
  const src = fifty ? (theme === "light" ? "/brand/ep-group-50-dark.png" : "/brand/ep-logo-50-white.png")
    : theme === "light" ? "/brand/ep-group-dark.png" : "/brand/ep-group-white.png";
  return <img src={src} alt="EP Group" className={`w-auto select-none ${className}`} draggable={false} data-testid={testid} />;
};
